<template>
  <div class="calendar-navigation">
    <button class="nav-button" @click="navigate('previous')">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
           class="icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"></path>
      </svg>
    </button>
    <button class="nav-button center-button" @click="goToToday">I dag</button>
    <button class="nav-button" @click="navigate('next')">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
           class="icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"></path>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    navigate (direction) {
      if (direction === 'previous') {
        this.$emit('prev')
      } else if (direction === 'next') {
        this.$emit('next')
      }
    },
    goToToday () {
      this.$emit('today')
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.calendar-navigation {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translate(-50%);
  z-index: 1221;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--primary);
  border-radius: 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-button {
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
  transition: background-color 0.2s;
  color: #fff;
}

.center-button {
  align-items: center;
  border-radius: 0;
  border-left: 1px solid hsl(0deg 0% 100% / 25%);
  border-right: 1px solid hsl(0deg 0% 100% / 25%);
  flex: 1;
  justify-content: center;
  width: 65px;
}

.icon {
  width: 24px;
  height: 24px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// BottomNav.vue?4ef575da